var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.meta)?_c('span',{staticClass:"cc-method"},[_c('span',{staticClass:"ms cc-method-icon"},[_vm._v(_vm._s(_setup.meta.icon))]),_vm._v(" "+_vm._s(_setup.meta.label)+" ")]):_c('span',{staticClass:"cc-method cc-method--none"},[_vm._v("—")])
}
var staticRenderFns = []

export { render, staticRenderFns }